<script>

import auth from "./router/layouts/auth"
import PublicLayout from "./router/layouts/public.vue"
import chat from "./router/layouts/chat"
import cloud from "./router/layouts/cloud";
import account from "./router/layouts/account";
import mainLayout from "./router/layouts/main";
import GatedRouterView from "./router/GatedRouterView.vue";
import TimezonePrompt from "@components/global/TimezonePrompt.vue";
import UserSettingsModal from "@components/global/UserSettingsModal.vue";
import QuotaExceededModal from "@components/global/QuotaExceededModal.vue";
import ConfirmDialog from "@components/global/ConfirmDialog.vue";
import RouterProgressBar from "@components/global/RouterProgressBar.vue";
import ApiStatusBanner from "@components/global/ApiStatusBanner.vue";
import NewVersionPill from "@components/global/NewVersionPill.vue";
import {mapState} from "vuex";
export default {
  components:{auth, PublicLayout, chat, cloud, account, mainLayout, GatedRouterView, TimezonePrompt, UserSettingsModal, QuotaExceededModal, ConfirmDialog, RouterProgressBar, ApiStatusBanner, NewVersionPill},
  page: {
  },
  computed:{
    ...mapState({
      userSettings: state => state.settings.userSettings,
    }),
    getLayout(){
      return this.$route.meta.layout
    },
    hideWidgets() {
      if (this.getLayout === 'public') return true;
      const denyPaths = ['chat', 'calendar', 'cloud', 'purchase-athlisis'];
      return denyPaths.some(p => this.$route.path.includes(p));
    },
    hideTimezonePrompt() {
      return this.hideWidgets || this.getLayout === 'auth';
    },
    hideProlipsisWidget() {
      return this.isEducational || this.isOfflineVersion || this.hideWidgets || !this.$store.getters['auth/loggedIn'] || this.userSettings?.prolipsis_widget === false;
    },
    hideChatBot() {
      return this.hideWidgets || this.userSettings?.chat_bot === false;
    }
  },
  watch:{
    hideChatBot: {
      immediate: true,
      handler(hide) {
        this.$nextTick(() => {
          if (window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
            hide ? window.Tawk_API.hideWidget() : window.Tawk_API.showWidget();
          }
        });
      }
    }
  },
}

</script>

<template>
  <div id="app">

    <main-layout v-if="!getLayout">
      <gated-router-view />
    </main-layout>
    <chat v-else-if="getLayout === 'chat'">
      <gated-router-view />
    </chat>
    <auth v-else-if="getLayout === 'auth'">
      <gated-router-view />
    </auth>
    <public-layout v-else-if="getLayout === 'public'">
      <gated-router-view />
    </public-layout>
    <cloud v-else-if="getLayout === 'cloud'">
      <gated-router-view />
    </cloud>
    <account v-else-if="getLayout === 'account'">
      <gated-router-view />
    </account>

    <router-progress-bar />
    <notifications group="athlisis-notifications" data-testid="notifications"></notifications>
    <timezone-prompt v-if="!hideTimezonePrompt" />
    <user-settings-modal v-if="$store.getters['auth/loggedIn']" />
    <quota-exceeded-modal />
    <confirm-dialog />
    <api-status-banner />
    <new-version-pill />
    <prolipsis-widget v-if="!hideProlipsisWidget" class="tablet-desktop-only" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
.apexcharts-svg .apexcharts-legend { position: fixed !important; }
  // Design variables and utilities from src/design.
  @import '@design';
  p, li, h1,h2,h3,h4,h5,h6{
    font-family: "Manrope",sans-serif!important;
  }
  .vue-notification-group{
    top:30px!important;
    right:10px!important;
  }
  .img-elements-not-found{
    margin-top:60px;
  }
  .headline-not-found{
    font-weight: 900!important;
  }
  
  input[type="text"]:disabled, input[type="number"]:disabled, .custom-select:disabled {
    background: $color_input_disabled_bg!important;
    opacity: 0.7;
  }
  .questionnaire-tabs{
    .custom-control-label{
      cursor:pointer!important;
    }
  }

  #prolipsis-app .prolipsis-widget-toggle {
    width: 40px!important;
    height: 40px!important;
    padding: 4px!important;
    bottom: 100px!important;
    right: 24px!important;
    border-radius: 50%!important;
    border: 1.5px solid rgba(31,41,55,0.15)!important;
    box-shadow: none!important;
    transition: transform 0.15s ease, border-color 0.2s ease!important;

    &:hover {
      transform: scale(1.08)!important;
      border-color: rgba(31,41,55,0.35)!important;
    }

    &.active-widget {
      border-color: $color_primary!important;
      border-width: 2px!important;
    }

    img {
      width: 24px!important;
      height: 24px!important;
    }
  }
</style>
